import Button from './01-atoms/button/button';
import Attachment from './01-atoms/inputs/attachment';
import Range from './01-atoms/inputs/range';
import Intro from './01-atoms/animations/intro';
import Selectthema from './01-atoms/inputs/selectthema';
import Share from './02-molecules/share/share';
import Accordion from './02-molecules/accordion/accordion';
import Alerts from './02-molecules/alerts/alerts';
import Popup from './02-molecules/popup/popup';
import Slider from './02-molecules/slider/slider';
import Timeline from './02-molecules/timeline/timeline';
import Teasers from './02-molecules/threeTeaser/teasers';
import Filter from './02-molecules/filter/filter';
import Dialogues from './02-molecules/dialogues/dialogues';
import Cards from './02-molecules/cards/cards';
import Newsgrid from './02-molecules/newsGrid/newsgrid';
import Newsanimation from './02-molecules/newsGrid/newsanimation';
import Location from './02-molecules/location/location';
import Form from './02-molecules/contactForm/form';
import VideoBlock from './02-molecules/videoBlock/videoBlock';
import Testimonials from './02-molecules/testimonials/testimonials';
import GoogleMap from './02-molecules/location/gmaps';
import Footer from './03-organisms/footer/footer';
import Header from './03-organisms/header/header';

import './main.scss';

function ready(fn) {
  if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(() => {
  const html = document.querySelector('html');
  const Component = window.Streusel || {};

  html.classList.remove('no-js');

  Component.Button = Button.init();
  Component.Range = Range.init();
  Component.Dialogues = Dialogues.init();
  Component.Share = Share.init();
  Component.Intro = Intro.init();
  Component.Accordion = Accordion.init();
  Component.Alerts = Alerts.init();
  Component.Popup = Popup.init();
  Component.Slider = Slider.init();
  Component.Timeline = Timeline.init();
  Component.Attachment = Attachment.init();
  // Component.Select = Select.init();
  Component.Location = Location.init();
  Component.GoogleMap = GoogleMap.init();
  Component.Newsgrid = Newsgrid.init();
  Component.Cards = Cards.init();
  Component.Newsanimation = Newsanimation.init();
  Component.Form = Form.init();
  Component.Selectthema = Selectthema.init();
  Component.Footer = Footer.init();
  Component.Header = Header.init();
  Component.Teasers = Teasers.init();
  Component.VideoBlock = VideoBlock.init();
  Component.Filter = Filter.init();
  Component.Testimonials = Testimonials.init();
});
